export function createElementFromHtml<T extends Element>( html: string ): T {
  const template = document.createElement( 'template' );
  template.innerHTML = html;
  return template.content.children[ 0 ] as T;
}
